import { Component, OnInit, ViewChild, ElementRef, Renderer2, Input, OnChanges, SimpleChanges, AfterViewInit, EventEmitter, Output } from '@angular/core';
import _ from 'lodash';

@Component({
  selector: 'app-floorplan-edit',
  templateUrl: './floorplan-edit.component.html',
  styleUrls: ['./floorplan-edit.component.scss']
})
export class FloorplanEditComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() spaceData;
  @Input() mediaData;
  @Input() floorPlanData;
  @Output() closeModalEmit = new EventEmitter();
  @ViewChild('floorplanImageDiv') floorplanImageDiv: ElementRef;
  @ViewChild('floorPlanImage') floorPlanImage: ElementRef;
  showHotspot = false;
  hotspotsData = [];

  currentSelectedHotspot: any;


  // Canvas element
  imageEl = new Image();
  canvasEl: any;
  canvasContext: any;
  ctx: CanvasRenderingContext2D;
  canvasWidth = 669.25;
  canvasHeight = 669.25;
  imageObj = new Image();

  hotspotHeightWidth = 30;

  showHotspotData = false;

  constructor(public renderer: Renderer2) { }

  ngOnInit() {
  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.showHotspotData = true;
    }, 2000);
  }

  resizeHandler(event) {
    this.getHeightWidthHotspot();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.floorPlanData && changes.floorPlanData.currentValue) {
      if (changes.floorPlanData.currentValue.hotspot) {
        this.hotspotsData = changes.floorPlanData.currentValue.hotspot;
      }
    }
  }

  toggleMenuEmit(response) {
    this.showHotspot = response;
  }

  floorPlanClicked(event) {
    if (this.showHotspot) {
      return;
    }
    this.createNewHotspot(event);
  }

  createNewHotspot(event) {
    const element = $(this.floorPlanImage.nativeElement);
    this.currentSelectedHotspot = {
      id: Math.random().toString(36).substr(2, 9),
      position: {
        x: (event.offsetX / element.width()) * 100 - 2, // Substract -2 to get exact mouse around value
        y: (event.offsetY / element.height()) * 100 - 2, // Substract -2 to get exact mouse around value
      },
    };
    this.hotspotsData.push(this.currentSelectedHotspot);
    this.showHotspot = true;
  }

  getHeightWidthHotspot() {
    const element = $(this.floorPlanImage.nativeElement);
    const width = element.width() / 25;
    return width < 30 ? width : 30;
  }

  closeFoorPlanEmit(response) {
    if (this.currentSelectedHotspot && !this.currentSelectedHotspot.uuid) {
      this.hotspotsData = _.filter(this.hotspotsData, (hotspot) => {
        return hotspot.id !== this.currentSelectedHotspot.id;
      });
    }
    this.currentSelectedHotspot =  undefined;
    this.showHotspot = false;
  }

  createHotspotEmit(response) {
    if (this.currentSelectedHotspot) {
      this.hotspotsData = _.map(this.hotspotsData, (hotspot) => {
        if (hotspot.id === this.currentSelectedHotspot.id) {
          return response;
        }
        return hotspot;
      });
      this.floorPlanData.hotspot.push(response);
    }
    this.currentSelectedHotspot =  undefined;
    this.showHotspot = false;
  }

  updateHotspotEmit(response) {
    if (this.currentSelectedHotspot) {
      this.hotspotsData = _.map(this.hotspotsData, (hotspot) => {
        if (hotspot.uuid && hotspot.uuid === this.currentSelectedHotspot.uuid) {
          return response;
        }
        return hotspot;
      });
    }
    this.currentSelectedHotspot =  undefined;
    this.showHotspot = false;
  }

  deleteHotspotEmit(response) {
    this.hotspotsData = _.filter(this.hotspotsData, (hotspot) => {
      const isValid = hotspot.uuid && response.uuid && hotspot.uuid === response.uuid;
      return !isValid;
    });
    this.currentSelectedHotspot =  undefined;
    this.showHotspot = false;
  }

  editHotspot(hotspot) {
    if (!this.showHotspot) {
      this.currentSelectedHotspot = hotspot;
      this.showHotspot = true;
    }
  }

  closeModal() {
    this.closeModalEmit.emit(true);
  }

}
